import { type SidepanelSide } from '@shared/sidepanel/side'

interface TourConnectorProps {
  /** Distance from the card's top edge to the spotlighted target's center. */
  offsetY: number
  /** Screen edge the panel is docked to — the connector points that way. */
  side: SidepanelSide
  gap: number
}

/** Hairline bridging the gap between the card and the spotlighted section. */
export function TourConnector({ offsetY, side, gap }: TourConnectorProps) {
  return (
    <span
      aria-hidden="true"
      className="bg-white-11 absolute h-px shadow-[0_0_2px_rgba(0,0,0,0.25)]"
      style={{ top: offsetY, width: gap, [side]: -gap }}
    />
  )
}
